// Inbox de notificacoes: junta as linhas de notifications (RLS ja filtra por
// tenant + globais publicadas) com os receipts (lido/dispensado) do tenant.

export type NotificationKind =
  | "announcement"
  | "connection_down"
  | "credential_reauth"
  | "destination_lost"
  | "plan_limit";
export type NotificationSeverity = "info" | "warning" | "critical";

export interface NotificationRow {
  readonly id: string;
  readonly tenant_id: string | null;
  readonly kind: NotificationKind;
  readonly severity: NotificationSeverity;
  readonly title: string;
  readonly body_md: string;
  readonly image_url: string | null;
  readonly action_url: string | null;
  readonly published_at: string;
  readonly resolved_at: string | null;
}

export interface ReceiptRow {
  readonly notification_id: string;
  readonly read_at: string | null;
  readonly dismissed_at: string | null;
}

export interface InboxItem {
  readonly id: string;
  readonly kind: NotificationKind;
  readonly severity: NotificationSeverity;
  readonly title: string;
  readonly body: string;
  readonly imageUrl: string | null;
  readonly actionUrl: string | null;
  readonly publishedAt: string;
  readonly isAlert: boolean;
  /** Alerta de integracao ainda nao resolvido. */
  readonly isActiveAlert: boolean;
  readonly read: boolean;
}

export interface Inbox {
  readonly items: readonly InboxItem[];
  readonly unreadCount: number;
  readonly activeAlerts: readonly InboxItem[];
}

/** Monta a inbox: tira dispensadas, ordena por alerta ativo e depois data. */
export function buildInbox(rows: readonly NotificationRow[], receipts: readonly ReceiptRow[]): Inbox {
  const byId = new Map(receipts.map((r) => [r.notification_id, r]));
  const items = rows
    .filter((row) => !byId.get(row.id)?.dismissed_at)
    .map((row): InboxItem => {
      const isAlert = row.kind !== "announcement";
      return {
        id: row.id,
        kind: row.kind,
        severity: row.severity,
        title: row.title,
        body: row.body_md,
        imageUrl: row.image_url,
        actionUrl: row.action_url,
        publishedAt: row.published_at,
        isAlert,
        isActiveAlert: isAlert && row.resolved_at === null,
        read: Boolean(byId.get(row.id)?.read_at),
      };
    })
    .sort((a, b) => Number(b.isActiveAlert) - Number(a.isActiveAlert) || b.publishedAt.localeCompare(a.publishedAt));
  return {
    items,
    unreadCount: items.filter((item) => !item.read).length,
    activeAlerts: items.filter((item) => item.isActiveAlert),
  };
}

/** Rotulo curto do contador do sino (9+ acima de 9). */
export function badgeLabel(count: number): string | null {
  if (count <= 0) return null;
  return count > 9 ? "9+" : String(count);
}
